module.exports = __webpack_public_path__ + "static/04-708e2ea464577075acddacc97cd662d3.jpg";